import { Component, OnInit } from "@angular/core";
import {
  MatCard,
  MatCardActions,
  MatCardContent,
  MatCardHeader,
  MatCardTitle,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import {
  MatFormField,
  MatInput,
  MatLabel,
  MatSuffix,
} from '@angular/material/input';
import { MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { AutenticacaoService } from "../../services";
import { Router } from "@angular/router";
import { firstValueFrom } from 'rxjs';

interface login {
  email: string;
  senha: string;
}

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardActions,
    MatButton,
    MatInput,
    MatFormField,
    MatCardTitle,
    MatLabel,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    MatSuffix,
    FormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  login: login = {
    email: '',
    senha: '',
  };

  constructor(private toastr: ToastrService, private autenticacaoService: AutenticacaoService, private router: Router) {}

  ngOnInit(): void {
    if (this.autenticacaoService.isLogado()) {
      this.router.navigate(['/home']);
    }
  }

  entrar(): void {
    if (!this.login.email || !this.login.senha) {
      this.toastr.error('Email e senha devem ser informados', 'Atenção!');
      return;
    }

    firstValueFrom(this.autenticacaoService.login(this.login.email,this.login.senha)).then(result=> {

      if (result) {
        this.toastr.success('Login efetuado com sucesso!', 'Sucesso');
        this.router.navigate(['/']);
      } else {
        this.toastr.error('Email ou senha incorretos', 'Atenção!');
      }
    }).catch(error=>{
      this.toastr.error('Erro ao efetuar login', 'Erro');
    })

  }

  cancelar() {
    this.router.navigate(['/']);
  }
}
